import { ChangeDetectorRef, Component, Output } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { AbstractControl, FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, ValidationErrors, ValidatorFn, Validators } from '@angular/forms';
import { RippleModule } from 'primeng/ripple';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';
import { InputOtpModule } from 'primeng/inputotp';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { InputMaskModule } from 'primeng/inputmask';
import { AccountService } from '../../services/account.service';
import { MasterService } from '../../services/master.service';
import { Constants } from '../../helpers/constants';
import { EventEmitter } from '@angular/core';

@Component({
  selector: 'components-forgot-pass',
  imports: [InputMaskModule, TranslateModule, ReactiveFormsModule, ButtonModule, CheckboxModule, InputTextModule, PasswordModule, FormsModule, RouterModule, RippleModule, MessageModule, ToastModule, InputOtpModule, CommonModule],
  templateUrl: './forgot-pass.html',
  styleUrl: './forgot-pass.css',
})
export class ForgotPass {
  userForm: FormGroup;
  findId = 1;
  findPass = 2;
  phonenumber: string = '';
  submit: boolean = false;
  type: number = 0;

  visibleForgot: boolean = false;

  otp: any;

  @Output() loginClick = new EventEmitter<boolean>();

  constructor(private fb: FormBuilder, private translate: TranslateService, private accountService: AccountService,
    private masterService: MasterService, private router: Router, private cdr : ChangeDetectorRef
  ) {
    this.userForm = this.fb.group(
      {
        Password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.pattern(/^(?=\S+$)(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/)
          ],
        ],
        ConfirmPassword: ['', [
          Validators.required,
          Validators.minLength(8),
          Validators.pattern(/^(?=\S+$)(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/),
          this.matchPasswords()
        ]],
      },
      { validators: this.matchPasswords() }
    );
  }

  matchPasswords(): ValidatorFn {
    return (group: AbstractControl): ValidationErrors | null => {
      const password = group.get('Password')?.value;
      const confirmPassword = group.get('ConfirmPassword')?.value;

      if (password !== confirmPassword) {
        group.get('ConfirmPassword')?.setErrors({ passwordMismatch: true });
        return { passwordMismatch: true };
      }

      if (group.get('ConfirmPassword')?.hasError('passwordMismatch')) {
        group.get('ConfirmPassword')?.setErrors(null);
      }

      return null;
    };
  }
  find(type: number) {
    this.getId(type);
  }

  onOtpChange(value: string) {
    if (value?.length === 6) {
      this.masterService.showSuccess(this.translate.instant('MESSCODE.MS0000000006'));
    }

  }

  onPhoneInput(event: Event) {
    const input = event.target as HTMLInputElement;
    const original = input.value;
    input.value = original.replace(/[eE\+\-]/g, '');
    input.value = input.value.replace(/[^0-9]/g, '');

    if (input.value.length <= 10) {
      input.value = input.value.replace(/(\d{3})(\d{3})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    } else {
      input.value = input.value.substring(0, 11);
      input.value = input.value.replace(/(\d{3})(\d{4})(\d{0,4})/, (_, a, b, c) => {
        return c ? `${a}-${b}-${c}` : `${a}-${b}`;
      });
    }

    this.phonenumber = input.value;
  }

  id: any;

  getId(type: number) {
    this.submit = true;
    if (this.phonenumber) {
      this.accountService.getIdByPhone(this.phonenumber).subscribe((res: any) => {
        if (res?.isOK) {
          this.id = res?.result;
          this.type = type;
          this.visibleForgot = true;
        }
        else {
          this.masterService.showError(Constants.showError(res?.errorMessages))
        }
        this.submit = false;
        this.cdr.detectChanges();
      })
    }
  }


  countdown: number = 180;
  countdownInterval: any;
  value: string = '';

  startCountdown() {
    this.countdown = 180;
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
    this.countdownInterval = setInterval(() => {
      if (this.countdown > 0) {
        this.countdown--;
      } else {
        clearInterval(this.countdownInterval);
      }
    }, 1000);
  }

  resendOTP(event: Event) {
    event.preventDefault();

    this.value = '';

    this.startCountdown();
  }

  formatTime(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${this.padZero(minutes)}:${this.padZero(seconds)}`;
  }

  padZero(n: number): string {
    return n < 10 ? '0' + n : n.toString();
  }

  changePass() {
    if (this.userForm.valid) {
      this.accountService.changePassword(this.phonenumber, this.userForm.value.Password).subscribe((res: any) => {
        if (res?.isOK && res?.result?.dataRes) {
          this.masterService.showSuccess(this.translate.instant('LOGINHQ0030'))
          setTimeout(() => {
            this.loginClick.emit(true)
          }, 300);
        }
        else {
          this.masterService.showError(Constants.showError(res?.errorMessages))
        }
      })
    }
    else {
      this.userForm.markAsDirty();
      this.userForm.markAllAsTouched();
    }
  }

  redirectLogin() {
    this.loginClick.emit(true)
  }
}
